module.exports = __webpack_public_path__ + "img/stb.c947b756.png";